import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
// import FormSelectField from 'components/ui/form/FormSelectField';
import FormSimpleSelectField from 'components/ui/form/FormSimpleSelectField';
import FormTreeSelectField2 from 'components/ui/form/FormTreeSelectField2';
import FormDateField from 'components/ui/form/FormDateField';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(3, { label: 'block.addModal.validation.nameMin', value: 3 })
    .required('block.addModal.validation.name'),
  // object_id: yup.number().required('block.addModal.validation.objectId'),
  blocks: yup.array().min(1, 'block.addModal.validation.objectId'),
  type: yup.number().required('block.addModal.validation.objectId'),
});

const DiscountSettingsAddModal = ({
  open,
  setOpen,
  refetch,
  selectedDiscount,
  setSelectedDiscount,
}) => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sendNotification = useNotification();

  const formik = useFormik({
    initialValues: {
      name: '',
      object_id: '',
      type: '',
      blocks: [],
      from: null,
      till: null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const response = await axiosPrivate.post(
          selectedDiscount?.id
            ? `/admin/discount/update/${selectedDiscount?.id}`
            : '/admin/discount/store',
          JSON.stringify(values),
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.data && response.data.status) {
          sendNotification({
            msg: t('settings.discounts.addDiscountModal.alert.success', {
              value: values.name,
            }),
            variant: 'success',
          });
          setIsSubmitting(false);
          refetch();
          handleClose();
        }
      } catch (error) {
        sendNotification({
          msg: error?.response?.data?.message || error?.message,
          variant: 'error',
        });
        setIsSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (selectedDiscount) {
      formik.setValues({
        name: selectedDiscount?.name || '',
        // object_id: selectedDiscount?.object_id || '',
        blocks: selectedDiscount?.blocks || '',
        type: selectedDiscount?.type ?? '',
        from: selectedDiscount?.from || null,
        till: selectedDiscount?.till || null,
      });
    }
  }, [selectedDiscount]);

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
    setSelectedDiscount(null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-md',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-gray-100 text-center !mb-2'
      >
        <span>{t('settings.discounts.addDiscountModal.title')}</span>
      </DialogTitle>

      <DialogContent sx={{ width: '650px' }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.1}
                label={t('common.fields.simpleName')}
                fieldName='name'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              {/* <FormSelectField
                delay={0.2}
                fieldName='object_id'
                label={t('common.fields.objectName')}
                formik={formik}
                path={'/dictionary/objects2'}
              /> */}
              <FormTreeSelectField2
                fieldName={'blocks'}
                label={`${t('boss.residentialComplex.title')} (${t(
                  'common.fields.blocks'
                )})`}
                childOptionField={'blocks'}
                formik={formik}
                parentLabel={'name'}
                parentValue={'id'}
                childLabel={'name'}
                childValue={'id'}
                variant='standard'
                path='/dictionary/objects3'
                size='small'
                onChange={() => {}}
                progress={false}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSimpleSelectField
                delay={0.3}
                fieldName='type'
                label={t('settings.discounts.addDiscountModal.typeDiscount')}
                options={[
                  {
                    id: 1,
                    name: t('settings.discounts.addDiscountModal.types.type1'),
                  },
                  {
                    id: 0,
                    name: t('settings.discounts.addDiscountModal.types.type0'),
                  },
                ]}
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormDateField
                delay={0.4}
                fieldName='from'
                label={t('common.table.from')}
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormDateField
                delay={0.5}
                fieldName='till'
                label={t('common.table.till')}
                formik={formik}
              />
            </Grid>
            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.6}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default DiscountSettingsAddModal;
